import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetSymphonyImportErrorsDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../common/hooks/useTranslation';
import momencik from '../../../common/momencik';

import { SymphonyResendLink } from './SymphonyResendLink';

interface SymphonyImportErrorsSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
}

export const symphonyImportErrorsForGrid = (
  importErrors: GetSymphonyImportErrorsDto,
) => {
  return {
    key: importErrors.tbInvoiceId.toString(),
    values: {
      'error.salesInvoiceSystemNumber': importErrors.salesInvoiceSystemNumber,
      'error.salesInvoiceNumber': (
        <>
          {importErrors.salesInvoiceNumber}
          <SymphonyResendLink
            salesInvoiceId={importErrors.salesInvoiceId}
            modificationDate={importErrors.modificationDate}
          />
        </>
      ),
      'error.salesInvoiceCorrectedNumber':
        importErrors.salesInvoiceCorrectedNumber || '',
      'error.currency': importErrors.currency,
      'error.symphonyNumberCodes': importErrors.symphonyNumberCodes,
      'error.importErrors': importErrors.importErrors,
      'error.modificationDate': momencik(importErrors.modificationDate),
    },
  };
};

export const SymphonyImportErrorsSearch: React.FC<
  SymphonyImportErrorsSearchProps
> = props => {
  const { t, tk } = useTranslation('fvsLng');

  const columns: GridColumn[] = [
    {
      header: t(tk.common.sysNumber),
      property: 'error.salesInvoiceSystemNumber',
    },
    {
      header: t(tk.finance.invoiceNumber),
      property: 'error.salesInvoiceNumber',
    },
    {
      header: t(tk.finance.correctedInvoiceNumber),
      property: 'error.salesInvoiceCorrectedNumber',
    },
    { header: t(tk.common.currency), property: 'error.currency' },
    { header: t(tk.symphony.codes), property: 'error.symphonyNumberCodes' },
    { header: t(tk.common.errors), property: 'error.importErrors' },
    {
      header: t(tk.common.modificationDate),
      property: 'error.modificationDate',
    },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="error.modificationDate"
      initialOrderDirection="DESC"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={t(tk.symphony.noImportErrors)}
      withHistory={true}
    />
  );
};
